module.exports = __webpack_public_path__ + "img/Antigua and Barbuda.48296de8.gif";